<template app>
<div class="blog-post">
  <v-flex xs12 class="caption pt-1 pb-1 text-xs-left"><b>{{filters.label ? filters.label :''}}</b></v-flex>
     <v-autocomplete attach  
        :items="items"
        :item-text="filters.name"
        :item-value="filters.id"
        v-model="selectedOption"
        persistent-hint
        single-line

        hide-details
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        cache-items
        :chips="needChip"
        :outline="outlineBorder"
        dense
        small
        small-chips
        :clearable="needChip"
        :deletable-chips="needChip"
        :return-object="returnObject"
        :multiple="multipleOptions"
      >
        </v-autocomplete> 
</div>
</template>

<script>
import DropDownModel from '@/api/service/DropDownService'

  export default {
   props: ["filters","value",  "sIndex", "returnObject", "multipleOptions",
   "needChip", "outlineBorder"],

 data () {
      return {
          selectedId:0,
          items:[]
      }
    },
    computed: {
      selectedOption: {
          get() {return this.filters.defaultValue},
          set(selected) { 
            //this.filters.defaultValue = selected;
            //alert(selected)
            this.$emit('input', selected);
            //this.$emit('change')
            }
      }
    },
    watch: {
      value() {
        this.$emit('input',this.value)
      }
    },
    created: function() {
        console.log(this.filters)
    DropDownModel.getReportLookup(this.filters.dataSet)
        .then(response => {
            this.setItems(response)                
        }).catch(error => {
            console.log(error)
    });
  },
  methods: {
      triggerEvent($v,$event) {
          //console.log(selected)
          //console.log($event)
          /*var $json ={}
          var  $objs ={}
          $json[this.filters.id]=$v;
           if(this.sIndex>=0) {
                $objs.selected = $json
                $objs.index = this.sIndex
                this.$emit("change",$objs)
            } else {
          this.$emit('change',$json)
            }           */
          //this.$emit('change',this.value)

      },
      setItems(items) {
          var $i=0;
          var $exclude ={}
          $exclude[this.filters.id]='!'
          $exclude[this.filters.name]='Exclude'
          this.items.push($exclude)
          for($i=0;$i<items.length;$i++) {
          this.items.push(items[$i]) 
      }
      }
      }
  }
</script>